import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import FormHelperText from "@mui/material/FormHelperText";
import Stack, { StackProps } from "@mui/material/Stack";
import ValidationResult from "../../interfaces/api/validation-result";
import i18n from "../../i18n";
import { DatePicker } from "@mui/x-date-pickers";

interface DateInputProps extends StackProps {
  date: DateTime | null;
  title?: string;
  dateValidation?: ValidationResult;
  minDate?: DateTime;
  maxDate?: DateTime;
  inputTestId?: string;
  disabled?: boolean;
  onDateTimeChange: (datetime: DateTime | null) => void;
}

const DateInput: React.FC<DateInputProps> = ({
  date,
  title,
  dateValidation,
  minDate,
  maxDate,
  inputTestId,
  disabled,
  onDateTimeChange,
  sx,
  ...props
}) => {
  return (
    <Stack {...props} gap={0} width="100%">
      <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={i18n.language}>
        <DatePicker
          sx={{ ...sx }}
          value={date}
          label={title}
          slotProps={{
            textField: {
              variant: "standard",
              inputProps: inputTestId ? { "data-testid": inputTestId } : undefined,
            },
          }}
          onChange={onDateTimeChange}
          minDate={minDate}
          maxDate={maxDate}
          format="dd/MM/yyyy"
          disabled={disabled}
        />
      </LocalizationProvider>
      {dateValidation?.error && (
        <FormHelperText
          sx={(theme) => ({ paddingLeft: 2, color: dateValidation.isValid ? undefined : theme.palette.error.main })}
        >
          {dateValidation.error}
        </FormHelperText>
      )}
    </Stack>
  );
};

export default DateInput;
